import { COMPANY } from "@/data/company";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0F172A] text-white pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 pb-12 border-b border-white/15">
          <div className="lg:col-span-6">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/50">
              Shree Ambey Roadlines
            </div>
            <div className="mt-3 text-white/80 max-w-md leading-relaxed">
              A Kanpur-based road transport company moving government and
              private payloads across India with reliability and care.
            </div>
          </div>
          <div className="lg:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/50 mb-3">
              Contact
            </div>
            <div className="space-y-2 text-white/80 text-sm">
              {COMPANY.owners.map((o) => (
                <div key={o.name} className="flex items-center justify-between">
                  <span>{o.name}</span>
                  <a
                    href={`tel:${o.phone}`}
                    className="font-mono font-bold text-white hover:text-[#F59E0B]"
                  >
                    {o.phone}
                  </a>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-white/50 mb-3">
              Address
            </div>
            <div className="text-white/80 text-sm leading-relaxed">
              {COMPANY.address.line1}
              <br />
              {COMPANY.address.line2}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 pt-6 text-xs text-white/50">
          <div>© {year} Shree Ambey Roadlines. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <a
              href="/admin/inquiries"
              data-testid="footer-admin-link"
              className="hover:text-white transition-brutal"
            >
              Admin
            </a>
            <span>Kanpur, UP · India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
